import FincasOverview from '../../features/fincas/layouts/overview';

// TSS vite/01 — thin page. Monta la feature de fincas: la grilla CRUD. Sin
// :id (la edición es modal, no ruta). Guarded por <AuthRoute> (shell) + gateado
// a los roles de datos partner/donor_owner en el catálogo de nav.

export default function FincasPage() {
    return <FincasOverview />;
}
